import { FormInput } from 'src/@types';
import { getDefaultValue } from 'src/components/shared/form-elements';
import { CalculatorsHomeValueStep4FormFields } from '../../../../../@types/features/calculators';
import { IntlShape } from 'react-intl/src/types';

export const useCalculatorHomeValueStep4FormFields = (intl: IntlShape) => {
  const calculatorHomeValueStep4FormFields: Record<
    keyof CalculatorsHomeValueStep4FormFields,
    FormInput
  > = {
    propertyPlans: {
      fieldName: 'propertyPlans',
      label: '',
      type: 'radio',
      required: true,
      options: [
        {
          label: intl.formatMessage({
            id: 'step4.propertyPlans.buy',
            defaultMessage: 'Kopen'
          }),
          value: 'buy'
        },
        {
          label: intl.formatMessage({
            id: 'step4.propertyPlans.sell',
            defaultMessage: 'Verkopen'
          }),
          value: 'sell'
        },
        {
          label: intl.formatMessage({
            id: 'step4.propertyPlans.unknown',
            defaultMessage: 'Ik ben gewoon benieuwd'
          }),
          value: 'unknown'
        }
      ],
      defaultValue: getDefaultValue('buy')
    }
  };
  return calculatorHomeValueStep4FormFields;
};
